// src/components/ChatWindow.jsx

import React, { useState, useEffect, useRef } from 'react';
import { useChat } from '../context/ChatProvider';
import { useAuth } from '../context/AuthProvider';
import { FaPaperPlane, FaUserCircle } from 'react-icons/fa';

export function ChatWindow() {
  const { activeConversation, sendMessage } = useChat();
  const { user: agent } = useAuth();
  const [inputText, setInputText] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [activeConversation?.messages]);

  // Clear input when switching conversations
  useEffect(() => {
      setInputText('');
  }, [activeConversation?.id]);


  const handleSend = (e) => {
    e.preventDefault();
    if (inputText.trim()) {
      sendMessage(inputText);
      setInputText('');
    }
  };

  if (!activeConversation) {
    return (
      <div className="flex flex-col items-center justify-center h-full bg-gray-50 text-gray-500">
        <div className="text-center p-8">
            <FaUserCircle size={80} className="mb-4 text-gray-300 mx-auto" />
            <h2 className="text-2xl font-bold text-gray-700">Welcome to the Command Center</h2>
            <p className="mt-2">Select an active chat from the top bar or accept a new request from the inbox.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full bg-gray-100">
      {/* Message Area */}
      <div className="flex-1 p-4 md:p-6 overflow-y-auto space-y-4">
        {activeConversation.messages.map((msg, index) => {
            if(msg.sender === 'system') {
                return (
                    <div key={index} className="text-center my-4">
                        <span className="text-xs text-gray-500 bg-gray-200 px-3 py-1 rounded-full">{msg.text}</span>
                    </div>
                )
            }
            return (
              <div key={index} className={`flex items-end gap-2.5 max-w-xl ${msg.sender === 'agent' ? 'ml-auto flex-row-reverse' : 'mr-auto'}`}>
                <div className={`w-8 h-8 rounded-full flex-shrink-0 ${msg.sender === 'agent' ? 'bg-blue-600' : 'bg-gray-400'}`}></div>
                <div className={`px-4 py-2.5 rounded-2xl ${msg.sender === 'agent' ? 'bg-blue-600 text-white rounded-br-lg' : 'bg-white text-gray-800 rounded-bl-lg shadow-sm'}`}>
                  <p className="text-sm whitespace-pre-wrap">{msg.text}</p>
                </div>
              </div>
            )
        })}
        <div ref={messagesEndRef} />
      </div>
      
      {/* Input Area */}
      <div className="p-4 bg-white border-t border-gray-200 mt-auto">
        <form onSubmit={handleSend} className="flex items-center gap-4">
          <input
            type="text" value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="Enter your message..."
            className="flex-1 px-5 py-3 bg-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus
          />
          <button type="submit"
            className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-transform hover:scale-105"
            aria-label="Send Message"
          >
            <FaPaperPlane size={20} />
          </button>
        </form>
      </div>
    </div>
  );
}